import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { VideoProps } from '../../modals/video-player-modal/models/video-data';
import { IVideo } from '../../interfaces/videosByCategory';
import { VideoPlayerModalComponent } from '../../modals/video-player-modal/video-player-modal.component';
import { Subject } from 'rxjs';
import { SendingFidelityProgramEventsService } from 'src/app/services/fidelity-program-event/sending-fidelity-program-events.service';
import { IWatchVideoEventModel } from 'src/app/services/fidelity-program-event/models/fidelity-program-event-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Injectable({
  providedIn: 'root'
})
export class VideoModalHandlerService {
  private modalRef: BsModalRef<VideoPlayerModalComponent>;
  private modalStateSubject = new Subject<boolean>();

  modalState$ = this.modalStateSubject.asObservable();

  constructor(
    private modalService: BsModalService,
    private sendingFidelityProgramEventsService: SendingFidelityProgramEventsService,
    private authService: AuthenticationService,
    private notificationService: NotificationService
  ) {}

  openVideoModal(video: IVideo, isLive: boolean) {
    try {
      const videoProps: VideoProps = {
        url: video.videoURL,
        videoTitle: video.title,
        videoSubtitle: video.subtitle
      };
      this.modalRef = this.modalService.show(VideoPlayerModalComponent, {
        initialState: videoProps as Partial<VideoPlayerModalComponent>,
        animated: true,
        class: 'modal-xl',
        ignoreBackdropClick: false
      });

      this.modalStateSubject.next(true);

      const vetId = this.authService.getUserId();
      const metaData = JSON.stringify({
        videoTitle: video.title,
        videoUrl: video.videoURL
      });

      if (isLive) {
        const participationEventPayload = {
          idVet: this.authService.getUserId(),
          idEvent: video.id,
          metaData: metaData
        };

        this.sendingFidelityProgramEventsService
          .participationInEvent(participationEventPayload)
          .subscribe({
            next: () => {
              console.log(
                'Evento de participação em evento emitido com sucesso'
              );
            },
            error: (err) => {
              console.error(
                'Erro ao emitir evento de participação em evento:',
                err
              );
            }
          });
      } else {
        this.emitWatchVideoEvent(video, vetId, metaData);
      }

      this.modalRef.onHide?.subscribe(() => {
        this.modalStateSubject.next(false);
      });
    } catch (error) {
      this.notificationService.error(
        'Erro ao abrir o player de vídeo. Verifique a URL e tente novamente.'
      );
      console.error('Erro ao abrir o modal: ', error);
    }
  }

  private emitWatchVideoEvent(
    video: IVideo,
    vetId: number,
    metaData: string
  ): void {
    const eventTriggerService = this.sendingFidelityProgramEventsService;
    const eventPayload: IWatchVideoEventModel = {
      idVet: vetId,
      idEvent: video.id,
      metadata: metaData
    };
    eventTriggerService.watchVideo(eventPayload).subscribe({
      next: () => {
        console.log('Watch video event sent successfully');
      },
      error: (error) => {
        this.notificationService.error(
          `Não foi possível registrar o evento de assistir vídeo.`
        );
        console.error('Error sending watch video event:', error);
      }
    });
  }
}
